export const getInstallationImages = (orderVehicleId: string) => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/images/installation/${orderVehicleId}`,
    method: 'GET',
  }
}
